import React, { useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../../../api/baseUrl";
import getDecryptedToken from "../../../../../../../../api/getDecryptedToken";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { insertBreaks } from "../../../../../../../../utils/functions/resize";

const user: string | undefined = getDecryptedToken("userName");

function AllSubTreatmentTr({
  items,
  paid,
  refresh,
  _id,
  allTeatment,
  setallTeatment,
  item,
}: any) {
  const dateNow = new Date();
  const { ID } = useParams();
  const [status, setstatus] = useState(items?.status);
  const handleDelete = (e: any) => {
    setallTeatment((prevTreatments: any) =>
      prevTreatments.map((item: any) => {
        if (item._id === _id) {
          return {
            ...item,
            subTreatment: item.subTreatment.filter(
              (subItem: any) => subItem._id !== e
            ),
          };
        }
        return item;
      })
    );
    baseUrl
      .patch("/client/treatments/subTreatment/delete-subtreetment", {
        maintreatmentid: ID,
        treatmentid: _id,
        subtreatmentid: e,
      })
      .then((response) => {
        refresh();
        console.log(response?.data);
      })
      .catch((error) => {
        console.error("Error removing treatment:", error);
      });
  };
  const handleSelectClick = () => {
    if (items?._id === undefined) {
      refresh();
    }
  };
  const handleSelect = (e: any) => {
    if (items?._id) {
      setstatus(e.target.value);
      baseUrl
        .patch(
          "/client/treatments/subTreatment/add-subtreetmentStatus",
          { status: e.target.value },
          {
            headers: {
              maintreatmentid: ID,
              treatmentid: item._id,
              subtreatmentid: items._id,
            },
          }
        )
        .then((response) => {
          refresh();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <tr>
      <td data-label="Date">
        {new Date(items?.createdAt)
          ? new Date(items?.createdAt).toISOString()?.split("T")[0] +
            "/" +
            new Date(items?.createdAt).toISOString()?.split("T")[1]?.slice(0, 5)
          : new Date(dateNow).toISOString()}
      </td>
      <td data-label="Treatment">
        {items?.treatment}
        {items?.type ? "-" + items?.type : ""}
        {items?.subtype ? "-" + items?.subtype : ""}
      </td>
      <td data-label="tooth No">{items?.toothNo}</td>
      <td data-label="surface">{items?.surface}</td>
      <td data-label="Quantity">{items?.quantity}</td>
      <td data-label="price">{items?.price}</td>
      {items?.selected_option === "treatment_paid"  ? (
        <td data-label="Status" onClick={handleSelectClick}>
          <select value={status} onChange={handleSelect}>
            {!items?.paid && <option value="planned">Planned</option>}
            <option value="ongoing">Ongoing</option>
            <option value="Complete">Complete</option>
          </select>
        </td>
      ) : (
        <td>{status}</td>
      )}
      <td data-label="Dentist">
        {items?.didBy
          ? items?.didBy?.firstName +
            " " +
            (items?.didBy?.lastName != null ? items?.didBy?.lastName : "")
          : user}
      </td>
      <td data-label="note">{insertBreaks(items?.note)}</td>
      <td>
        {!items?.paid && (
          <button className="delete" onClick={() => handleDelete(items?._id)}>
            <DeleteOutlineIcon />
          </button>
        )}
      </td>
    </tr>
  );
}

export default AllSubTreatmentTr;
